module.exports = __WEBPACK_EXTERNAL_MODULE_19__;


//////////////////
// WEBPACK FOOTER
// external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react","umd":"react"}
// module id = 19
// module chunks = 0